// SEQ-193 follow-on: renders its children only for a viewer who may see P&L.
//
// Everything that fetches P&L data (the metric registry read, the analytics
// RPC) lives INSIDE the children, so a viewer without access never mounts
// those hooks: no empty card, no heading, no network call. `loading` covers
// the moment before the profile is known, when nothing is shown either.
//
// Written with createElement, not JSX, so a deno test can render it without
// a JSX transform (same reason as components/Money.ts).

import { createElement, Fragment, type ReactElement, type ReactNode } from "react";
import { canSeeDashboardPnlMonthOnMonth } from "./dashboardMonthOnMonth.ts";

export interface FinancialAccessGateProps {
  profile: { can_view_financials?: boolean | null } | null | undefined;
  /** True while the signed-in profile is still loading. */
  loading: boolean;
  children?: ReactNode;
}

export function FinancialAccessGate({ profile, loading, children }: FinancialAccessGateProps): ReactElement | null {
  if (loading) return null;
  if (!canSeeDashboardPnlMonthOnMonth(profile)) return null;
  return createElement(Fragment, null, children);
}
